// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3rjKJ","inputWrap":"CustomTip_inputWrap__3WFIq"};